import { InputAdornment, IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

export function ClearableSelectAdornment({ 
  value, 
  onClear, 
  position = "end",
  adornmentProps = {},
  iconButtonProps = {} 
}) {
  const { t } = useTranslation();
  if (!value || value === '') return null;

  return (
    <InputAdornment
      position={position}
      sx={{
        position: "absolute",
        bottom: 20,
        right: 40,
        display: "flex",
        alignItems: "center",
        pointerEvents: "none",
        ...adornmentProps.sx,
      }}
      {...adornmentProps}
    >
      <IconButton
        onClick={onClear}
        size="small"
        edge="end"
        aria-label={t("Clear")}
        title={t("Clear")}
        sx={{
          pointerEvents: "auto",
          ...iconButtonProps.sx,
        }}
        {...iconButtonProps}
      >
        <Close fontSize="small" />
      </IconButton>
    </InputAdornment>
  );
}